import type { FieldValues } from 'state/persisted/request-create/types';

export const createPlaceholderValueMap = (
    fieldValues: FieldValues,
    placeholderKeys: string[]
): { [key: string]: string } => {
    // This reducer takes the field keys specified by the BE and grabs the relevant values from the form
    // to construct a map of values for the specified fields
    // This map is used by the CmdbObectPicker to determine when to display a default value based on an IQL query
    const placeholderValuesReducer = (accumulator: { [key: string]: string }, currentPlaceholder: string) => {
        if (fieldValues[currentPlaceholder]) {
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call,  @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            accumulator[currentPlaceholder] = fieldValues[currentPlaceholder]?.toString() || '';
        }
        return accumulator;
    };

    return placeholderKeys?.reduce(placeholderValuesReducer, {});
};
